import React, { useEffect, useRef } from 'react';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import DrUsamaImage from '@images/dr-usama.png';
import AbdulWasayImage from '@images/AbdulWasay.png';
import UsmanImage from '@images/usman.png';
import NoumanImage from '@images/nouman.png';

const Testimonials = () => {
  const revealContainer = useRef(null);
  const revealTestimonials = useRef([]);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }
    const timer = setTimeout(() => {
      if (revealContainer.current) {
        sr.reveal(revealContainer.current, srConfig());
      }
      revealTestimonials.current.forEach((ref, i) => {
        if (ref) {
          sr.reveal(ref, srConfig(i * 150, 0.15));
        }
      });
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const testimonials = [
    {
      id: 1,
      content:
        "Sarim has shown exceptional dedication and analytical thinking in his academic pursuits. His research interests in AI/ML and his ability to bridge theoretical concepts with practical applications make him a promising researcher and developer in the field of computer science.",
      author: 'Dr. Muhammad Usama',
      title: 'Associate Professor',
      company: 'FAST NUCES',
      avatar: 'MU',
      image: DrUsamaImage,
    },
    {
      id: 2,
      content:
        "Working with Sarim at AIESEC has been exceptional. His strategic thinking and leadership skills in business development initiatives have significantly contributed to our global expansion efforts. His ability to combine technical expertise with business acumen makes him a valuable asset to any organization.",
      author: 'Abdul Wasay',
      title: 'Global Business Development Manager',
      company: 'AIESEC',
      avatar: 'AW',
      image: AbdulWasayImage,
    },
    {
      id: 3,
      content:
        "Working alongside Sarim at FAST NUCES has been an incredible experience. His problem-solving skills and collaborative approach make him an excellent team member. His expertise in software engineering and AI/ML projects consistently delivers outstanding results.",
      author: 'Usman Aamir',
      title: 'Peer',
      company: 'FAST NUCES',
      avatar: 'U',
      image: UsmanImage,
    },
    {
      id: 4,
      content:
        "Sarim is one of the most dedicated and talented peers I've worked with at FAST NUCES. His technical knowledge, especially in machine learning and full-stack development, combined with his willingness to help others, makes him a valuable colleague and friend.",
      author: 'Muhammad Nouman',
      title: 'Peer',
      company: 'FAST NUCES',
      avatar: 'N',
      image: NoumanImage,
    },
  ];

  return (
    /* testimonial-card and related classes defined in global.css */
    <section
      id="testimonials"
      ref={revealContainer}
      tabIndex="-1"
      className="max-w-[1000px] mx-auto relative">

      {/* Section background glow — global.css handles ::before pseudo-element */}
      <h2 className="numbered-heading">What People Say</h2>

      <div className="flex flex-col gap-[30px]">
        {testimonials.map((testimonial, i) => (
          <div
            key={testimonial.id}
            className="testimonial-card"
            ref={el => (revealTestimonials.current[i] = el)}>

            {/* testimonial-content quote marks via ::before/::after (global.css) */}
            <div className="testimonial-content">
              <p>{testimonial.content}</p>
            </div>

            <div className="testimonial-author">
              <div className={`author-avatar${testimonial.image ? ' has-image' : ''}`}>
                {testimonial.image ? (
                  <img src={testimonial.image} alt={testimonial.author} />
                ) : (
                  testimonial.avatar
                )}
              </div>

              <div className="author-info">
                <h4 className="name">{testimonial.author}</h4>
                <p className="title">{testimonial.title}</p>
                <p className="company">{testimonial.company}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
